export const TIME_DATA = [
  [1551438000000, 8.3203125],
  [1551438030000, 7.9140625],
  [1551438060000, 7.8671875],
  [1551438090000, 7.125],
  [1551438120000, 8.765625],
  [1551438150000, 11.546875],
  [1551438180000, 12.984375],
  [1551438210000, 13.546875],
  [1551438240000, 13.390625],
  [1551438270000, 11.5625],
  [1551438300000, 11.5859375],
  [1551438330000, 10.0546875],
  [1551438360000, 9.921875],
  [1551438390000, 9.4921875],
  [1551438420000, 9.78125],
  [1551438450000, 10.046875],
  [1551438480000, 14.0546875],
  [1551438510000, 10.640625],
  [1551438540000, 8.2421875],
  [1551438570000, 8.5],
  [1551438600000, 7.2578125],
  [1551438630000, 8.515625],
  [1551438660000, 10.796875],
  [1551438690000, 11.125],
  [1551438720000, 21.40625],
  [1551438750000, 17.921875],
  [1551438780000, 26.640625],
  [1551438810000, 31.390625],
  [1551438840000, 23.953125],
];

export const TIME_DATA_2 = [
  [1551438000000, 9.984375],
  [1551438030000, 9.71875],
  [1551438060000, 9.28125],
  [1551438090000, 9.078125],
  [1551438120000, 8.9921875],
  [1551438150000, 9.640625],
  [1551438180000, 10.171875],
  [1551438210000, 10.421875],
  [1551438240000, 10.625],
  [1551438270000, 10.390625],
  [1551438300000, 10.4296875],
  [1551438330000, 10.1328125],
  [1551438360000, 9.984375],
  [1551438390000, 9.8203125],
  [1551438420000, 9.8125],
  [1551438450000, 9.78125],
  [1551438480000, 10.625],
  [1551438510000, 10.09375],
  [1551438540000, 9.5546875],
  [1551438570000, 9.390625],
  [1551438600000, 9.015625],
  [1551438630000, 8.8828125],
  [1551438660000, 9.359375],
  [1551438690000, 9.53125],
  [1551438720000, 11.9453125],
  [1551438750000, 11.828125],
  [1551438780000, 14.4609375],
  [1551438810000, 16.421875],
  [1551438840000, 15.6875],
];

export const SIMPLE_GITHUB_DATASET = [
  {
    authorAssociation: 'Team Member',
    vizType: 'Data Table',
    issueType: 'Bug',
    count: 24000,
  },
  {
    authorAssociation: 'Team Member',
    vizType: 'Heatmap',
    issueType: 'Bug',
    count: 12000,
  },
  {
    authorAssociation: 'Team Member',
    vizType: 'Markdown',
    issueType: 'Bug',
    count: 6000,
  },
  {
    authorAssociation: 'Team Member',
    vizType: 'MetricVis',
    issueType: 'Bug',
    count: 16000,
  },
  {
    authorAssociation: 'Team Member',
    vizType: 'Pie Chart',
    issueType: 'Bug',
    count: 7000,
  },
  {
    authorAssociation: 'Team Member',
    vizType: 'Tagcloud',
    issueType: 'Bug',
    count: 19000,
  },
  {
    authorAssociation: 'Team Member',
    vizType: 'TSVB',
    issueType: 'Bug',
    count: 86000,
  },
  {
    authorAssociation: 'Team Member',
    vizType: 'Timelion',
    issueType: 'Bug',
    count: 58000,
  },
  {
    authorAssociation: 'Team Member',
    vizType: 'Vega vis',
    issueType: 'Bug',
    count: 11000,
  },
  {
    authorAssociation: 'Team Member',
    vizType: 'Point Series',
    issueType: 'Bug',
    count: 1000,
  },
  {
    authorAssociation: 'Team Member',
    vizType: 'Inspector',
    issueType: 'Bug',
    count: 15000,
  },
];

export const GITHUB_DATASET = [
  {
    authorAssociation: 'Team Member',
    vizType: 'Data Table',
    issueType: 'Bug',
    count: 24000,
  },
  {
    authorAssociation: 'Team Member',
    vizType: 'Data Table',
    issueType: 'Other',
    count: 22000,
  },
  {
    authorAssociation: 'Team Member',
    vizType: 'Heatmap',
    issueType: 'Bug',
    count: 12000,
  },
  {
    authorAssociation: 'Team Member',
    vizType: 'Heatmap',
    issueType: 'Other',
    count: 6000,
  },
  {
    authorAssociation: 'Team Member',
    vizType: 'Markdown',
    issueType: 'Bug',
    count: 6000,
  },
  {
    authorAssociation: 'Team Member',
    vizType: 'Markdown',
    issueType: 'Other',
    count: 11000,
  },
  {
    authorAssociation: 'Team Member',
    vizType: 'MetricVis',
    issueType: 'Bug',
    count: 16000,
  },
  {
    authorAssociation: 'Team Member',
    vizType: 'MetricVis',
    issueType: 'Other',
    count: 8000,
  },
  {
    authorAssociation: 'Team Member',
    vizType: 'Pie Chart',
    issueType: 'Bug',
    count: 7000,
  },
  {
    authorAssociation: 'Team Member',
    vizType: 'Pie Chart',
    issueType: 'Other',
    count: 4000,
  },
  {
    authorAssociation: 'Team Member',
    vizType: 'Tagcloud',
    issueType: 'Bug',
    count: 19000,
  },
  {
    authorAssociation: 'Team Member',
    vizType: 'Tagcloud',
    issueType: 'Other',
    count: 13000,
  },
  {
    authorAssociation: 'Team Member',
    vizType: 'TSVB',
    issueType: 'Bug',
    count: 86000,
  },
  {
    authorAssociation: 'Team Member',
    vizType: 'TSVB',
    issueType: 'Other',
    count: 123000,
  },
  {
    authorAssociation: 'Team Member',
    vizType: 'Timelion',
    issueType: 'Bug',
    count: 58000,
  },
  {
    authorAssociation: 'Team Member',
    vizType: 'Timelion',
    issueType: 'Other',
    count: 93000,
  },
  {
    authorAssociation: 'Team Member',
    vizType: 'Vega vis',
    issueType: 'Bug',
    count: 11000,
  },
  {
    authorAssociation: 'Team Member',
    vizType: 'Vega vis',
    issueType: 'Other',
    count: 38000,
  },
  {
    authorAssociation: 'Team Member',
    vizType: 'Point Series',
    issueType: 'Bug',
    count: 1000,
  },
  {
    authorAssociation: 'Team Member',
    vizType: 'Point Series',
    issueType: 'Other',
    count: 1000,
  },
  {
    authorAssociation: 'Team Member',
    vizType: 'Inspector',
    issueType: 'Bug',
    count: 15000,
  },
  {
    authorAssociation: 'Team Member',
    vizType: 'Inspector',
    issueType: 'Other',
    count: 11000,
  },
];

export const GITHUB_DATASET_MOD = [
  {
    total: 'Total',
    vizType: 'Data Table',
    issueType: 'Bug',
    count: 24,
  },
  {
    total: 'Total',
    vizType: 'Data Table',
    issueType: 'Request',
    count: 22,
  },
  {
    total: 'Total',
    vizType: 'Tagcloud',
    issueType: 'Bug',
    count: 19,
  },
  {
    total: 'Total',
    vizType: 'Tagcloud',
    issueType: 'Request',
    count: 13,
  },
  {
    total: 'Total',
    vizType: 'TSVB',
    issueType: 'Bug',
    count: 86,
  },
  {
    total: 'Total',
    vizType: 'TSVB',
    issueType: 'Request',
    count: 123,
  },
  {
    total: 'Total',
    vizType: 'Timelion',
    issueType: 'Bug',
    count: 58,
  },
  {
    total: 'Total',
    vizType: 'Timelion',
    issueType: 'Request',
    count: 93,
  },
  {
    total: 'Total',
    vizType: 'Vega vis',
    issueType: 'Bug',
    count: 11,
  },
  {
    total: 'Total',
    vizType: 'Vega vis',
    issueType: 'Request',
    count: 38,
  },
  {
    total: 'Total',
    vizType: 'Other',
    issueType: 'Bug',
    count: 10,
  },
  {
    total: 'Total',
    vizType: 'Other',
    issueType: 'Request',
    count: 18,
  },
];

export const BROWSER_DATA_2019 = [
  {
    browser: 'Chrome',
    percent: 61.72,
  },
  {
    browser: 'Safari',
    percent: 15.23,
  },
  {
    browser: 'Firefox',
    percent: 4.66,
  },
  {
    browser: 'Samsung Internet',
    percent: '3.64',
  },
  {
    browser: 'UC Browser',
    percent: '3.83',
  },
  {
    browser: 'Opera',
    percent: '2.91',
  },
  {
    browser: 'IE',
    percent: '2.7',
  },
  {
    browser: 'Edge Legacy',
    percent: '2.13',
  },
  {
    browser: 'Android',
    percent: '1.15',
  },
  {
    browser: 'KaiOS',
    percent: '0.54',
  },
  {
    browser: 'Yandex Browser',
    percent: '0.24',
  },
  {
    browser: 'QQ Browser',
    percent: '0.22',
  },
  {
    browser: 'Puffin',
    percent: '0.12',
  },
  {
    browser: 'Coc Coc',
    percent: '0.09',
  },
  {
    browser: 'IEMobile',
    percent: '0.1',
  },
  {
    browser: 'Chromium',
    percent: '0.08',
  },
  {
    browser: 'Whale Browser',
    percent: '0.01',
  },
  {
    browser: 'Sogou Explorer',
    percent: '0.08',
  },
  {
    browser: 'Sony PS4',
    percent: '0.06',
  },
  {
    browser: 'mCent',
    percent: '0.21',
  },
  {
    browser: 'Maxthon',
    percent: '0.04',
  },
  {
    browser: 'Mozilla',
    percent: '0.03',
  },
  {
    browser: 'Vivaldi',
    percent: '0.02',
  },
  {
    browser: '360 Safe Browser',
    percent: '0.03',
  },
  {
    browser: 'Unknown',
    percent: '0.03',
  },
  {
    browser: 'BlackBerry',
    percent: '0.02',
  },
  {
    browser: 'Nokia',
    percent: '0.03',
  },
  {
    browser: 'Pale Moon',
    percent: '0.01',
  },
  {
    browser: 'Other',
    percent: '0.06',
  },
];

export const DAYS_OF_RAIN = [
  {
    season: 'Spring',
    days: 68,
    precipitation: 'rain',
  },
  {
    season: 'Summer',
    days: 46,
    precipitation: 'rain',
  },
  {
    season: 'Fall',
    days: 72,
    precipitation: 'rain',
  },
  {
    season: 'Winter',
    days: 24,
    precipitation: 'rain',
  },
  {
    season: 'Spring',
    days: 22,
    precipitation: 'none',
  },
  {
    season: 'Summer',
    days: 44,
    precipitation: 'none',
  },
  {
    season: 'Fall',
    days: 18,
    precipitation: 'none',
  },
  {
    season: 'Winter',
    days: 66,
    precipitation: 'none',
  },
];
